

var TRUE = true,
FALSE = false,
TYPE_OBJ = 'object',
PROTO = 'prototype',
WINDOWS = 'windows',
GECKO = 'gecko',
TYPE_UNDEF = "undefined",
MAX_UA_CACHE_SIZE = 10,
exp = {},
fitt = require("fitt"),

cstr = fitt.cstr,
cnum = fitt.cnum,
mix = fitt.mix,
kindOf = fitt.kindOf,
keys = fitt.keys,
regxTest = fitt.regxTest,
strMatch = fitt.strMatch,
strReplace = fitt.strReplace,
strlc = fitt.strlc,
oUAStrCache = {},
$UA = {},
sNavUA = function ()
{
    var ret = "";

    try {
        ret = typeof navigator == TYPE_OBJ ? cstr(navigator.userAgent) : '';
    } catch (e) {
        ret = '';
    }
    return ret;
}();

/**
      * Static utility function for doing string replace, where we guarantee
      * that the 1st argument and 3rd arguments are strings (hence being private,
      * and therefore speeding things up slightly since we don't have to convert).
      *
      * @name fitt.UA-strReplaceSafe
      * @function
      * @static
      * @private
      * @param {String} s The string in which to replace characters
      * @param {RegExp} ex The regular expression to use for replacement
      * @param {String|Function} r The replacement substring
      * @return {String}
      *
     */

function strReplaceSafe(s, ex, r)
{
    return strReplace(s, ex, r, TRUE, TRUE);
}

/**
   * Static utility function for doing a regular expression match on a string safely
   * (guaranteeing that the 1st argument is indeed a string, skipping any conversion),
   * and returning the array-like match object or a specific item out of said object
   * see {@link fitt.strMatch}
   *
   * @name fitt.UA-strMatchSafe
   * @function
   * @static
   * @private
   * @param {String} str
   * @param {RegExp} regEx
   * @param {Number} [idx=null] If null the return value is the array-like match result object or null, if idx is a number, then
   *                            it returns the item at the given index inside said match result object or null if not present
   * @return {Array|Null|String}
  */

function strMatchSafe(str, regEx, idx)
{
    return strMatch(str, regEx, idx, TRUE);
}

/**
   * Static utility function for doing a regular expression boolean match (test) on a string
   * safely  (guaranteeing that the 1st argument is indeed a regular expression and the 2nd
   * argument is a string, skipping any conversion).  See {@link fitt.regxTest}.
   *
   * @name fitt.UA-regxTestSafe
   * @function
   * @static
   * @private
   * @param {RegExp} rx
   * @param {String} str
   * @return {Boolean}
  */

function regxTestSafe(rx, str)
{
    return regxTest(rx, str, TRUE, TRUE);
}

/**
   * Converts a multi-dot version string into a numeric value
   * by replacing all dot characters except the first one.
   *
   * @name fitt.UA-convertVersionStringToNum
   * @function
   * @static
   * @private
   * @param {String} s A version number string (expected format of x.x.x).
   * @return {Number} Note that invalid strings which result in NaN values are converted to 0
   *
  */

function convertVersionStringToNum(s)
{
    var c = 0;

    function convertVersionStringToNumLogic()
    {
        return c++ == 1 ? '' : '.';
    }

    return cnum(strReplaceSafe(s, /\./g, convertVersionStringToNumLogic), 0);
}


/**
   * Parse a user-agent string, and mix the results into the given object
   *
   * @name fitt.UA-doParse
   * @function
   * @static
   * @private
   * @param {Object|fitt.UA} oUA An object to set the properties of; based on the information parsed from the given string. Properties
   *                             set map to the {@link fitt.UA} class properties.
   * @param {String} subUA A user-agent string to parse
   * @return oUA (the input object in the 1st argument is returned as well)
   *
  */

function doParse(oUA, subUA)
{
    var match, cached, keyList, keyListCnt;

    if (subUA) {
        cached = oUAStrCache[subUA];

        if (cached) {
            mix(oUA, cached);
        } else {
            if (regxTestSafe(/windows|win32/i, subUA)) {
                oUA.os = WINDOWS;
            } else if (regxTestSafe(/macintosh|mac_powerpc/i, subUA)) {
                oUA.os = 'macintosh';
            } else if (regxTestSafe(/android/i, subUA)) {
                oUA.os = 'android';
            } else if (regxTestSafe(/symbos/i, subUA)) {
                oUA.os = 'symbos';
            } else if (regxTestSafe(/linux/i, subUA)) {
                oUA.os = 'linux';
            } else if (regxTestSafe(/rhino/i, subUA)) {
                oUA.os = 'rhino';
            }

            /*
               * Edge browser actually includes sub strings for chrome,webkit, and safari
               * making you think it could be one of those browsers if your not careful,
               * so do that first
              */

            match = strMatchSafe(subUA, /Edge\/(\d+)\.*?(\d+)/, 1);
            if (match) {
                oUA.edge = convertVersionStringToNum(match);
                oUA.os = WINDOWS;
                match = strMatchSafe(subUA, /(Windows\s+?Phone)|(Mobile\s+?)Safari/i);

                if (match) {
                    oUA.mobile = WINDOWS;
                }
            } else {
                // Modern KHTML browsers should qualify as Safari X-Grade
                if (regxTestSafe(/KHTML/, subUA)) {
                    oUA.webkit = 1;
                }

                if (regxTestSafe(/IEMobile|XBLWP7/, subUA)) {
                    oUA.mobile = WINDOWS;
                }
                if (regxTestSafe(/Fennec/, subUA)) {
                    oUA.mobile = GECKO;
                }

                // Modern WebKit browsers are at least X-Grade
                match = strMatchSafe(subUA, /AppleWebKit\/([^\s]*)/, 1);

                if (match) {
                    oUA.webkit = convertVersionStringToNum(match);
                    oUA.safari = oUA.webkit;

                    if (regxTestSafe(/PhantomJS/, subUA)) {
                        match = strMatchSafe(subUA, /PhantomJS\/([^\s]*)/, 1);
                        if (match) {
                            oUA.phantomjs = convertVersionStringToNum(match);
                        }
                    }

                    // Mobile browser check
                    if (regxTestSafe(/ Mobile\//, subUA) || regxTestSafe(/iPad|iPod|iPhone/, subUA)) {
                        oUA.mobile = 'Apple'; // iPhone or iPod Touch

                        match = strMatchSafe(subUA, /OS ([^\s]*)/, 1);
                        match = match && convertVersionStringToNum(strReplaceSafe(match, /_/, '.'));
                        oUA.ios = match;
                        oUA.ipad = oUA.ipod = oUA.iphone = 0;

                        match = strMatchSafe(subUA, /iPad|iPod|iPhone/, 0);

                        if (match) {
                            oUA[strlc(match, TRUE)] = oUA.ios;
                        }

                    } else {
                        match = strMatchSafe(subUA, /NokiaN[^\/]*|Android \d\.\d|webOS\/\d\.\d/, 0);

                        if (match) {
                            // Nokia N-series, Android, webOS, ex: NokiaN95
                            oUA.mobile = match;
                        }

                        if (regxTestSafe(/webOS/, subUA)) {
                            oUA.mobile = 'WebOS';
                            match = strMatchSafe(subUA, /webOS\/([^\s]*);/, 1);

                            if (match) {
                                oUA.webos = convertVersionStringToNum(match);
                            }
                        }

                        if (regxTestSafe(/ Android/, subUA)) {
                            oUA.mobile = 'Android';
                            match = strMatchSafe(subUA, /Android ([^\s]*);/, 1);

                            if (match) {
                                oUA.android = convertVersionStringToNum(match);
                            }
                        }

                        if (regxTestSafe(/Silk/, subUA)) {
                            match = strMatchSafe(subUA, /Silk\/([^\s]*)\)/, 1);

                            if (match) {
                                oUA.silk = convertVersionStringToNum(match);
                            }

                            if (!oUA.android) {
                                oUA.android = 2.34; //Hack for desktop mode in Kindle
                                oUA.os = 'Android';
                            }

                            if (regxTestSafe(/Accelerated=true/, subUA)) {
                                oUA.accel = true;
                            }
                        }
                    }

                    match = strMatchSafe(subUA, /(Chrome|CrMo)\/([^\s]*)/);
                    if (match && match[1] && match[2]) {
                        oUA.chrome = convertVersionStringToNum(match[2]); // Chrome
                        oUA.safari = 0; //Reset safari back to 0

                        if (match[1] === 'CrMo') {
                            oUA.mobile = 'chrome';
                        }

                    } else {
                        match = strMatchSafe(subUA, /AdobeAIR\/([^\s]*)/);

                        if (match) {
                            oUA.air = match[0]; // Adobe AIR 1.0 or better
                        }
                    }
                }

                if (!oUA.webkit) {
                    match = strMatchSafe(subUA, /Opera[\s\/]([^\s]*)/, 1);
                    if (match) {
                        oUA.opera = convertVersionStringToNum(match);
                        match = strMatchSafe(subUA, /Opera Mini[^;]*/, 0);

                        if (match) {
                            oUA.mobile = match; // ex: Opera Mini/2.0.4509/1316
                        }
                    } else {// not opera or webkit

                        match = strMatchSafe(subUA, /MSIE ([^;]*)|Trident.*; rv:([0-9.]+)/);

                        if (match) {
                            match = match[1] || match[2];
                            oUA.ie = convertVersionStringToNum(match);
                        } else {// not opera, webkit, or ie
                            match = strMatchSafe(subUA, /Gecko\/([^\s]*)/);

                            if (match) {
                                oUA[GECKO] = 1; // Gecko detected, look for revision
                                match = strMatchSafe(subUA, /rv:([^\s\)]*)/, 1);

                                if (match) {
                                    oUA[GECKO] = convertVersionStringToNum(match);
                                }
                            }
                        }
                    }
                }
            }

            keyList = keys(oUAStrCache);
            keyListCnt = keyList && keyList.length || 0;
            if (keyListCnt > MAX_UA_CACHE_SIZE) {
                delete oUAStrCache[keyList[0]];
            }
            oUAStrCache[subUA] = oUA;
        }
    }
    try {
        if (typeof process == TYPE_OBJ) {
            if (process.versions && process.versions.node) {
                oUA.os = process.platform;
                oUA.nodejs = convertVersionStringToNum(process.versions.node);
            }
        }
    } catch (e) {
        oUA.nodejs = 0;
    }

    return oUA;
}

/**
   * A formal data object carrying user-agent and browser feature information
   *
   * @name fitt.UA
   * @class
   * @param {String} [str=''] The user-agent string to use to set properties in the object. If not specified,
   *                          it will attempt use the user-agent string from the browser dom (if running in a browser),
   *                          via navigator.userAgent
  */

/**
      * Carries the major version number of the browser if it's Internet Explorer, otherwise 0
      *
      * @name fitt.UA#ie
      * @type {Number}
      * @default 0
      *
     */

/**
         * Carries the major version number of the browser if it's Microsoft Edge, otherwise 0
         *
         * @name fitt.UA#edge
         * @type {Number}
         * @default 0
        */

/**
            * Carries the major version number of the browser if it's Opera, otherwise 0
            *
            * @name fitt.UA#opera
            * @type {Number}
            * @default 0
           */

/**
               * Carries the major version number of the browser if it's Gecko (thunderbird, firefox, old school mozilla/netscape), otherwise 0
               *
               * @name fitt.UA#gecko
               * @type {Number}
               * @default 0
               *
              */

/**
                  * Carries the major version number of the browser if it's Webkit based (usually Safari, old Chrome), otherwise 0
                  *
                  * @name fitt.UA#webkit
                  * @type {Number}
                  * @default 0
                 */

/**
                     * Carries the major version number of the browser if it's Safari, otherwise 0
                     *
                     * @name fitt.UA#safari
                     * @type {Number}
                     * @default 0
                    */

/**
                        * Carries the major version number of the browser if it's Chrome, otherwise 0
                        *
                        * @name fitt.UA#chrome
                        * @type {Number}
                        * @default 0
                       */

/**
                           * Carries the major version number of the browser if it's Adobe Air, otherwise 0
                           *
                           * @name fitt.UA#air
                           * @type {Number}
                           * @default 0
                          */

function UA(str)
{
    var me = this;

    if (!kindOf(me, $UA)) return new UA();

    if (str) {
        me = mix(me, UA_parse(str), TRUE, TRUE);
    } else {
        me = mix(me, $UA, TRUE, TRUE);
    }
    return me;
}

function UA_parse(str)
{
    var oUA = new UA();

    return doParse(oUA, str);
}

function UA_isMobile(str)
{
    var oUA = new UA();

    doParse(oUA, str);

    return !!oUA.mobile;
}

$UA.ie =
$UA.edge =
$UA.opera =
$UA.gecko =
$UA.webkit =
$UA.safari =
$UA.chrome =
$UA.air =
$UA.ipod =
$UA.ipad =
$UA.iphone =
$UA.android =
$UA.webos =
$UA.silk =
$UA.nodejs =
$UA.phantomjs = 0;

$UA.accel = FALSE;
$UA.mobile =
$UA.ios =
$UA.os =
$UA.caja = "";
$UA.parse =
UA.parse = UA_parse;
UA[PROTO] = $UA;

if (sNavUA) {
    doParse($UA, sNavUA);
}

exp.UA = UA;
exp.isMobile = UA_isMobile;

if (typeof module !== TYPE_UNDEF) {
    module.exports = exp;
}

fitt.ns("fitt.UA", UA);


//////////////////
// WEBPACK FOOTER
// ../~/espn-fitt/es5/fitt-ua/index.js
// module id = 760
// module chunks = 0